module.exports = __webpack_public_path__ + "static/media/alchemist.0d28a23f.png";